module.exports = __webpack_public_path__ + "static/media/logo.1921dff9.svg";